import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import VueMeta from 'vue-meta'
import { datadogRum } from '@datadog/browser-rum';

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import store from "@/store";

Vue.use(VueMeta)

datadogRum.init({
  applicationId: process.env.VUE_APP_DD_APP_ID,
  clientToken: process.env.VUE_APP_DD_CLIENT_TOKEN,
  site: 'us3.datadoghq.com',
  service: 'connect-systems',
  env: 'live',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackBfcacheViews: true,
  defaultPrivacyLevel: 'mask-user-input',
});

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
